import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ConeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.8746 10.6086C11.9366 10.8022 11.7921 11 11.5888 11H4.41085C4.2076 11 4.06313 10.8021 4.12508 10.6086L4.93755 8.06952C4.95081 8.0281 4.98931 8 5.03279 8H10.9669C11.0104 8 11.0489 8.0281 11.0621 8.06952L11.8746 10.6086Z"
		/>
		<path
			fill="currentColor"
			d="M9.94287 5C10.0106 5 10.0588 4.93405 10.0381 4.86952L8.86661 1.20857C8.82681 1.08432 8.71133 1 8.58084 1H7.41885C7.28836 1 7.17288 1.08432 7.13309 1.20857L5.96158 4.86952C5.94094 4.93405 5.98908 5 6.05683 5H9.94287Z"
		/>
		<path
			fill="currentColor"
			d="M3.99985 12C3.44754 12 2.99985 12.4477 2.99985 13C1.96268 13 1.10989 13.7895 1.00967 14.8003C0.998814 14.9102 1.08939 15 1.19986 15H14.7998C14.9103 15 15.0009 14.9102 14.99 14.8003C14.8898 13.7895 14.037 13 12.9998 13C12.9998 12.4477 12.5522 12 11.9998 12H3.99985Z"
		/>
	</svg>
))
